import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const FaqLazy = lazyLoader(() => import('./Faq' /* webpackChunkName: "faq" */));

const Faq = () => {
  return (
    <Suspense fallback={null}>
      <FaqLazy />
    </Suspense>
  );
};

export default Faq;
